import React from "react";

import Slide from "./Slide";

const SlideLeft = props => <Slide direction="left" {...props} />;

export default SlideLeft;
